module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "id": "customer-combined-chart"
    }
  }, [(!_vm.customerData.length) ? _c('div', {
    staticClass: "empty-tip"
  }, [_vm._v("\n    暂无数据可展示\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a849e774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/CategoryBar.vue
// module id = 1033
// module chunks = 3